"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RightRailFlyoutItem", {
  enumerable: true,
  get: function get() {
    return _RightRailFlyoutItem["default"];
  }
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _RightRailFlyout = _interopRequireDefault(require("./RightRailFlyout.context"));

var _RightRailFlyout2 = require("./RightRailFlyout.styles");

var _RightRailFlyoutItem = _interopRequireDefault(require("./RightRailFlyoutItem/RightRailFlyoutItem.index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RightRailFlyout = function RightRailFlyout(_ref) {
  var children = _ref.children,
      theme = _ref.theme;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _theme$rightRailFlyou = theme.rightRailFlyout;
  _theme$rightRailFlyou = _theme$rightRailFlyou === void 0 ? {} : _theme$rightRailFlyou;
  var _theme$rightRailFlyou2 = _theme$rightRailFlyou.squareWidth,
      squareWidth = _theme$rightRailFlyou2 === void 0 ? 55 : _theme$rightRailFlyou2;
  var rightRailFlyoutRef = (0, _react.useCallback)(function (node) {
    if (node !== null) {
      setWidth(node.getBoundingClientRect().width);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_RightRailFlyout["default"].Provider, {
    value: {
      width: width
    }
  }, /*#__PURE__*/_react["default"].createElement(_RightRailFlyout2.StyledRightRailFlyout, {
    ref: rightRailFlyoutRef,
    squareWidth: squareWidth,
    nodeWidth: width
  }, children));
};

RightRailFlyout.RightRailFlyoutItem = _RightRailFlyoutItem["default"];
var rightRailFlyoutItem = (0, _propTypes.shape)({
  type: (0, _propTypes.oneOf)([_RightRailFlyoutItem["default"]])
});
RightRailFlyout.propTypes = {
  /** RightRailFlyout Items to be rendered */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(rightRailFlyoutItem), rightRailFlyoutItem]).isRequired,

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired
};
RightRailFlyout.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RightRailFlyout",
  "props": {
    "children": {
      "description": "RightRailFlyout Items to be rendered",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "custom",
            "raw": "rightRailFlyoutItem"
          }
        }, {
          "name": "custom",
          "raw": "rightRailFlyoutItem"
        }]
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(RightRailFlyout);

exports["default"] = _default;